import { ArrowRight, Sparkles } from "lucide-react";
import { SITE } from "@/lib/site";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center pt-32 md:pt-36 pb-16 md:pb-24 overflow-hidden"
    >
      {/* decorative blobs */}
      <div
        aria-hidden
        className="absolute -top-40 -right-32 w-[520px] h-[520px] rounded-full opacity-40 blur-3xl"
        style={{ background: "radial-gradient(closest-side, #d9b86a55, transparent)" }}
      />
      <div
        aria-hidden
        className="absolute -bottom-40 -left-24 w-[480px] h-[480px] rounded-full opacity-50 blur-3xl"
        style={{ background: "radial-gradient(closest-side, #7c8b8455, transparent)" }}
      />

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center relative">
        <div className="lg:col-span-7 reveal">
          <span
            data-testid="hero-eyebrow"
            className="inline-flex items-center gap-2 text-xs md:text-sm uppercase tracking-[0.28em] text-brand-coral font-semibold"
          >
            <Sparkles size={14} /> Coaching for ADHD brains
          </span>

          <h1
            data-testid="hero-headline"
            className="mt-6 font-serif text-[52px] leading-[1.02] sm:text-7xl lg:text-8xl xl:text-[112px] tracking-tight text-brand-navy"
          >
            Turn <em className="italic text-brand-coral">stuck</em>
            <br />
            into <span className="italic">unstoppable.</span>
          </h1>

          <p
            data-testid="hero-subhead"
            className="mt-8 max-w-xl text-lg md:text-xl leading-relaxed text-brand-navy/75"
          >
            Learning how to work <em className="italic">with</em> your brain, not against it.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href={SITE.calendly}
              target="_blank"
              rel="noreferrer noopener"
              data-testid="hero-cta-primary"
              className="group inline-flex items-center justify-center gap-2 rounded-full bg-brand-coral text-brand-cream px-8 py-4 text-sm md:text-base font-medium tracking-wide hover:bg-brand-navy transition-colors duration-300"
            >
              Book a Free Discovery Call
              <ArrowRight
                size={18}
                className="transition-transform duration-300 group-hover:translate-x-1"
              />
            </a>
            <a
              href="#services"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-brand-sageDeep/30 text-brand-sageDeep px-8 py-4 text-sm md:text-base font-medium hover:border-brand-sageDeep hover:bg-white/50 transition"
            >
              Explore Services
            </a>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6 max-w-md">
            {[
              { k: "1:1", v: "Adults & Students" },
              { k: "1:1", v: "Parents" },
              { k: "Group", v: "Trainings" },
            ].map((s) => (
              <div key={s.v}>
                <div className="font-serif text-3xl text-brand-sageDeep">{s.k}</div>
                <div className="text-xs uppercase tracking-[0.18em] text-brand-navy/60 mt-1">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 reveal">
          <div className="relative">
            <div
              aria-hidden
              className="absolute inset-0 -translate-x-6 translate-y-6 rounded-[36px] bg-brand-gold/60"
            />
            <div className="relative overflow-hidden rounded-[36px] bg-brand-coral">
              <img
                src={SITE.headshotUrl}
                alt="Noa Grant — Parent and ADHD Coach"
                data-testid="hero-headshot"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 md:-left-10 bg-white/95 backdrop-blur rounded-2xl shadow-[0_20px_50px_rgba(47,66,80,0.12)] px-5 py-4 max-w-[260px] floaty">
              <div className="text-xs uppercase tracking-[0.2em] text-brand-coral font-semibold">
                Hi, I'm Noa
              </div>
              <p className="font-serif italic text-lg text-brand-navy mt-1 leading-snug">
                "Let's make ADHD work <em>with</em> you, not against you."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
